module.exports = __webpack_public_path__ + "static/media/website-in-progress-mobile.81f74704.svg";